module.exports = __webpack_public_path__ + "img/lab-room-two.c0520507.png";